/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosNodeListRequest = {
    sortField?: AptosNodeListRequest.sortField;
    sortDirection?: AptosNodeListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace AptosNodeListRequest {

    export enum sortField {
        VOTING_POWER = 'VOTING_POWER',
        REWARDS_PERFORMANCE = 'REWARDS_PERFORMANCE',
        LAST_EPOCH_PERFORMANCE = 'LAST_EPOCH_PERFORMANCE',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

